import { formatDate } from './dateUtils';

export const isGroupOrder = (orderReference: string): boolean => orderReference.charAt(0) === 'G';

export const isSingleOrder = (orderReference: string): boolean => orderReference.charAt(0) === 'B';

export const getICSFile = (description?: string, start?: string | Date, end?: string | Date): Blob => {
  if (!description || !start || !end) {
    return new Blob();
  }

  const startDate = formatDate('YYYY-MM-DD-T-HH-mm-ss', start).replaceAll('-', '');
  const endDate = formatDate('YYYY-MM-DD-T-HH-mm-ss', end).replaceAll('-', '');
  const uid = 'https://business.bt.com/';

  const lines = [
    'BEGIN:VCALENDAR',
    `PRODID:${uid}`,
    'VERSION:2.0',
    'BEGIN:VEVENT',
    `DTSTART:${startDate}`,
    `DTSTAMP:${startDate}`,
    `UID:${uid}`,
    `DTEND:${endDate}`,
    `SUMMARY:${description}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ];

  return new Blob([lines.join('\r\n')], { type: 'text/calendar' });
};
